export const getters = {
  systemPurchasegrn: state => state.purchase_receiving_item,
  systemPurchases: state => state.purchases
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/purchases/getters.js